import moment from "moment"

export default class ModeratorRightsTime {
    constructor () {

        this.currentTime = $('#moderator_rights_event_start_time')
        this.kinoAvailable = $('#moderator_rights_kino_available')
        this.duration = $('#moderator_rights_duration')
        this.startTimeContainer = $('#start_time')
        this.endTimeContainer = $('#end_time')

        this.events()
        this.onLoad()
    }

    events() {

    }

    onLoad() {
        console.log(this.currentTime)
        let current_time = moment(this.currentTime.val()).tz(moment.tz.guess())
        let end_time = current_time.clone().add(this.duration.val(), 'minutes')
        this.startTimeContainer.text(`${current_time.format('dddd, MMMM DD')} at ${current_time.format('hh:mm A')} ${current_time.zoneAbbr() }`)
        current_time.add(-15, 'minutes')
        this.kinoAvailable.text(`${current_time.format('dddd, MMMM DD')} at ${current_time.format('hh:mm A')} ${current_time.zoneAbbr() }`)
        this.endTimeContainer.text(`${end_time.format('dddd, MMMM DD')} at ${end_time.format('hh:mm A')} ${end_time.zoneAbbr() }`)
    }
}
